export default "__VITE_ASSET__kiUh4pzs__"